import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Toast, Typography } from '@chilecompra/react-kit/components'

import DownloadsNavButton from '../../components/Navigation/DownloadsNavButton'
import {
  Clipboard,
  ClipboardAction,
  ClipboardIcon,
  ClipboardIconCopied,
  ClipboardText,
  Container,
  Divider,
  DownloadIcon,
  List,
  ListItem,
  Root,
  Strong,
  Wrapper
} from './DownloadCfmpSection.styles'

const COPIED_FEEDBACK_MS = 3000

const data = [
  { id: 1, text: 'Falta de medios tecnológicos: los proveedores no pueden utilizar el sistema.' },
  { id: 2, text: 'Caso fortuito o fuerza mayor: situaciones de emergencia que requieren una contratación inmediata.' },
  {
    id: 3,
    text: 'Indisponibilidad técnica del sistema: cuando el sistema de compras públicas no se encuentra operativo.'
  },
  {
    id: 4,
    text: 'Contrataciones con proveedores extranjeros: cuando el proveedor es extranjero y no está inscrito en el sistema.'
  },
  { id: 5, text: 'Los antecedentes (garantías, planos, muestras u otros) no están disponibles en formato digital.' }
]

const downloadUrl = 'https://transparenciachc.blob.core.windows.net/oc-da/OC_CFMP.zip'

/**
 * The DownloadCfmpSection container.
 */
const DownloadCfmpSection = () => {
  const [copied, setCopied] = useState(false)
  const timerRef = useRef(null)

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(downloadUrl)
      setCopied(true)
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS)
    } catch {}
  }, [])

  const handleKeyDown = useCallback(
    event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        handleCopy()
      }
    },
    [handleCopy]
  )

  const handleClickDownload = useCallback(() => {
    const anchorElement = document.createElement('a')

    anchorElement.setAttribute('download', 'OC_CFMP.zip')
    anchorElement.setAttribute('href', downloadUrl)
    anchorElement.click()
  }, [])

  useEffect(() => () => clearTimeout(timerRef.current), [])

  return (
    <Root direction="column" gap="20px">
      <DownloadsNavButton />

      <Typography fontWeight="bold" variant="h3">
        Registro de Compras Fuera de Mercado Público
      </Typography>

      <Typography variant="body1">
        Consulta y descarga la información de las contrataciones realizadas fuera del Sistema de Información de Compras
        Públicas de Mercado Público por los organismos del Estado, en cumplimiento de lo establecido en el artículo 21
        de la Ley N.° 19.886 y el artículo 115 de su Reglamento.
      </Typography>

      <Typography variant="body1">
        En esta sección podrás visualizar las compras efectuadas bajo las siguientes causales que permiten realizar
        procesos fuera del sistema:
      </Typography>

      <List>
        {data.map(({ text, id }) => (
          <ListItem key={id}>{text}</ListItem>
        ))}
      </List>

      <Divider />

      <Wrapper>
        <DownloadIcon />

        <Container direction="column" gap="4px">
          <Typography variant="body2" italic>
            Copia la siguiente URL en tu navegador o descarga directamente el archivo
          </Typography>

          <Clipboard
            aria-label={copied ? 'URL copiada' : 'Copiar URL'}
            onClick={handleCopy}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
          >
            <ClipboardText>{downloadUrl}</ClipboardText>
            <ClipboardAction>{copied ? <ClipboardIconCopied /> : <ClipboardIcon />}</ClipboardAction>
          </Clipboard>
        </Container>

        <Button color="primary" onClick={handleClickDownload}>
          Descargar archivo
        </Button>
      </Wrapper>

      <Toast severity="info" title="¡Importante!">
        Los nuevos ingresos o modificaciones de información pueden tardar hasta <Strong> 24 horas</Strong> en verse
        reflejados en el archivo descargable.
      </Toast>
    </Root>
  )
}

export default DownloadCfmpSection
